<template>
  <tr>
    <td>
      {{
        price.visa_type.name
          ? `${price.visa_type.name}-Evisa-${price.visa_type.duration} jours-${
              price.visa_type.entry_mode === "SINGLE"
                ? "Entrée simple"
                : "Entrée multiple"
            }`
          : `Evisa-${price.visa_type.duration} jours-${
              price.visa_type.entry_mode === "SINGLE"
                ? "Entrée simple"
                : "Entrée multiple"
            }`
      }}
    </td>
    <td>{{ price.country ? price.country.name : "" }}</td>
    <td>{{ price.amount }}</td>
    <td>{{ price.from_office ? "Oui" : "Non" }}</td>
    <td>
      <!-- {{ price.state ? "Actif" : "Inactif" }} -->
      <button
        v-if="price.state && userPermissions.some((e) => [P_UPDATE_PRICE].includes(e))"
        class="btn btn-circle btn-success"
        title="Cliquer pour désactiver"
        @click="disable(price.id)"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        v-if="!price.state  && userPermissions.some((e) => [P_UPDATE_PRICE].includes(e))"
        class="btn btn-circle btn-danger"
        title="Cliquer pour activer"
        @click="enable(price.id)"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        v-if="!userPermissions.some((e) => [P_UPDATE_PRICE].includes(e))"
        class="btn btn-circle"     
        :class="{'btn-success': price.state, 'btn-danger': !price.state}"  
      >
        <i class="fas fa-check"></i>
      </button>
    </td>
    <td v-if="price.created_at">
      {{
        price.created_at
          | dateParse("YYYY-MM-DD HH:mm:ss")
          | dateFormat("DD/MM/YYYY HH:mm:ss")
      }}
    </td>
    <td v-else>{{ "" }}</td>
    <td>
      <button
        v-if="
          userPermissions.some((e) => [P_UPDATE_PRICE].includes(e))
        "
        class="btn btn-primary btn-circle mr-2"
        title="Modifier"
        @click="edit(price.id)"
      >
        <i class="fas fa-edit"></i></button
      ><button
        v-if="
          userPermissions.some((e) => [P_DELETE_PRICE].includes(e))
        "
        class="btn btn-danger btn-circle"
        title="Supprimer"
        @click="remove(price.id)"
      >
        <i class="fas fa-trash"></i>
      </button>

      <!-- Sup Modal-->
      <div
        class="modal fade"
        id="supModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Suppression</h5>
              <button
                class="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              Veuillez saisir votre mot de passe !
              <form @submit.prevent="handleSubmit">
                <br />
                <div class="form-group row">
                  <label :for="price.id">Mot de passe:</label>
                  <input
                    v-model="password"
                    type="password"
                    class="form-control col-md-8"
                    :class="{ 'is-invalid': submitted && !password }"
                    :id="price.id"
                    name="password"
                  />
                </div>
                <div class="modal-footer">
                  <button
                    class="btn btn-secondary btnAnnuler"
                    type="button"
                    data-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button class="btn btn-primary" type="submit">Valider</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

import {
  FETCH_PRICE,
  DELETE_PRICE,
  DISABLE_PRICE,
  ENABLE_PRICE,
} from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";

import {
  P_UPDATE_PRICE,
  P_DELETE_PRICE,
} from "@/helpers/permissions";

export default {
  name: "PriceItem",
  data() {
    return {
      password: "",
      submitted: false,
      id: "",
      P_UPDATE_PRICE,
      P_DELETE_PRICE,
    };
  },
  props: {
    price: { type: Object, required: true },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    handleSubmit() {
      this.submitted = true;

      if (this.submitted && !this.password) {
        return;
      }
      document.querySelector(".btnAnnuler").click();

      let { id, password } = this;

      this.$store
        .dispatch(DELETE_PRICE, { id, password })
        .then(() => {
          this.submitted = false;
          this.password = "";
          alert("Suppression effectuée !");
        })
        .catch((error) => {
          alert("Impossible d'effectuer l'opération", error);
        });
    },
    remove(id) {
      if (confirm("Voulez-vous vraiment supprimer cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);

        this.$store
          .dispatch(DELETE_PRICE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            alert("Suppression effectuée !");
          })
          .catch((error) => {
            this.$store.commit(SET_LOADING, false);
            alert("Impossible d'effectuer l'opération", error);
          });
      }
    },
    edit(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_PRICE, id)
        .then(() => {
          this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "price-edit" });
        })
        .catch(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    disable(id) {
      if (confirm("Voulez-vous vraiment désactiver cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);
        this.$store
          .dispatch(DISABLE_PRICE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            //this.$router.push({ name: "profile-edit" });
          })
          .catch(() => {
            this.$store.commit(SET_LOADING, false);
          });
      }
    },
    enable(id) {
      if (confirm("Voulez-vous vraiment activer cette ligne ?")) {
        this.$store.commit(SET_LOADING, true);
        this.$store
          .dispatch(ENABLE_PRICE, id)
          .then(() => {
            this.$store.commit(SET_LOADING, false);
            //this.$router.push({ name: "profile-edit" });
          })
          .catch(() => {
            this.$store.commit(SET_LOADING, false);
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>